import { useContext } from 'react';
import { LoginContext } from './LoginContext';

/**
 * Hook que devuelve datos sobre el estado de autenticación
 *  del usuario.
 * @return isLoggedin: indica si se encuentra autenticado.
 * @return logout: función para indicar que el usuario
 * deja de estar autenticado.
 * @return loginData: datos de autenticación.
 * @return checkLogin: función para verificar si
 * el usuario se encuentra autenticado. Se garantiza
 * que se vuelva a validar el estado de autenticación
 * al llamar esta función.
 */
export function useUserStatus() {
  const loginData = useContext(LoginContext);
  const isLoggedin: boolean = checkLogin();

  function logout() {
    loginData?.logoutUser?.();
  }
  function checkLogin(): boolean {
    return loginData != null && loginData.isValid();
  }
  return { isLoggedin, logout, loginData, checkLogin } as const;
}
